import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ChargeType = {
	name: NAME,
	apiProvider,
	router,
};
